import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useDevtoolsOpen } from '../../../utils/security/useDevtoolsOpen';
import { blockDevtoolsOnAuth } from '../../../config/auth';

/**
 * When enabled (prod builds), blocks auth UI while devtools appear open.
 * Wrap credential forms only — not the whole app.
 */
const DevtoolsGuard = ({ children }) => {
  const devtoolsOpen = useDevtoolsOpen(blockDevtoolsOnAuth);

  if (!blockDevtoolsOnAuth) {
    return children;
  }

  return (
    <Box
      sx={{ position: 'relative', width: '100%' }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {devtoolsOpen && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Close developer tools to sign in.
        </Alert>
      )}
      <Box
        sx={{
          pointerEvents: devtoolsOpen ? 'none' : 'auto',
          opacity: devtoolsOpen ? 0.45 : 1,
          userSelect: devtoolsOpen ? 'none' : 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DevtoolsGuard;
